// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"styles_overlayWrapper__ivpiW","saveButton":"styles_saveButton__gn7Z2"};